// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"DocumentErrorsInfobox__infoBoxContainer-dnDk"};